import { useIntl } from 'react-intl'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { DASH_SYMBOL } from 'app/consts'
import { LicenseType } from 'features/licenses/types'
import { prettyLicenseDescription } from 'features/licenses/utils'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { HomeLicensesMobileContainer } from '../styles'
import AddedLicenseNote from './AddedLicenseNote'
import { AddedLicensesMobileTitle } from './styles'
import { homeLicensingMessages } from '../messages'

interface AddedLicensesMobileProps {
  original: LicenseType
  values: Record<string, any>
}

function AddedLicensesMobile({ original, values }: AddedLicensesMobileProps) {
  const { formatMessage } = useIntl()

  return (
    <HomeLicensesMobileContainer>
      <AddedLicensesMobileTitle>
        <strong>{prettyLicenseDescription(original.description)}</strong>
        {values.name}
      </AddedLicensesMobileTitle>
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.licenseCode)}
        value={values.code}
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.orderNumber)}
        value={values.orderNumber}
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.purchaseOrder)}
        value={values.customerPO}
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.activated)}
        value={
          <IntlFormattedDate
            date={values.activated}
            withTime
            defaultReturn={DASH_SYMBOL}
          />
        }
      />
      <MobileLabelLine
        label={formatMessage(homeLicensingMessages.ends)}
        value={
          <IntlFormattedDate
            date={values.expiresAt}
            withTime
            defaultReturn={DASH_SYMBOL}
          />
        }
      />
      <AddedLicenseNote original={original} initialNote={values.notes} />
    </HomeLicensesMobileContainer>
  )
}

export default AddedLicensesMobile
